import script from "./Alpha.vue?vue&type=script&lang=ts&setup=true"
export * from "./Alpha.vue?vue&type=script&lang=ts&setup=true"

import "./Alpha.vue?vue&type=style&index=0&id=246b525c&lang=scss&scoped=true"

import exportComponent from "D:\\huishi-ppt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-246b525c"]])

export default __exports__